import { openAccountDlg } from '../dialogs/accountDlg';
import { openClientListDlg } from '../dialogs/clientListDlg';
import { openHistory } from '../dialogs/history';
import { openInbox } from '../dialogs/inbox';
import { openSubscriptionsDlg } from '../dialogs/subscriptionsDlg';
import { openUserOrgList } from '../dialogs/userOrgListDlg';
import { openUserPostings } from '../dialogs/userPostings';
import { state } from '../services/state';

export function UserBar() {
	return (
		<nav id="user_bar">
			<div class="inner">
				<a href="/">Home</a>

				{state.is_provider && <a onClick={(e) => openClientListDlg()}>Client Search</a>}
				{state.is_provider && <a onClick={(e) => openHistory()}>History</a>}

				<a onClick={(e) => openUserPostings()}>Posts</a>

				{state.is_provider && (
					<a
						onClick={(e) => {
							openUserOrgList();
						}}
					>
						{state.user_org?.name ||
							(state.user_orgs.length ? 'Select Organization' : 'Create Organization')}
					</a>
				)}

				{/* {state.is_provider && (
					<a
						onClick={(e) => {
							openSubscriptionsDlg();
						}}
					>
						Notifications
					</a>
				)} */}

				{state.inbox.length && <a onClick={(e) => openInbox()}>Inbox ({state.inbox.length})</a>}

				{state.sys_admin && (
					<a class="large" style={{ color: 'fuchsia' }} href="/admin">
						Admin
					</a>
				)}

				<span class="grow"></span>
				<a class="large" onClick={(e) => openAccountDlg(state.user)}>
					{state.user.name}
				</a>
				<a onClick={(e) => state.signOut()}>Sign Out</a>
			</div>
		</nav>
	);
}
